import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import colors from 'vuetify/es5/util/colors'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

export default new Vuetify({
  iconfont: 'mdi',
  theme: {
    themes: {
      light: {
        primary: colors.teal, // #009688
        secondary: colors.grey.darken4, // #FFCDD2
        accent: colors.teal.accent4 // #00695C
      }
    }
  }
})
